import React from 'react';
import ButtonBase from './ButtonBase';
import buttonPropTypes, { textAndA11yText } from './propTypes';
import { useThemeTokensCallback } from '../ThemeProvider';
import { a11yProps } from '../utils/props';
import { useViewport } from '../ViewportProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const Button = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    accessibilityRole = 'button',
    tokens,
    variant,
    ...props
  } = _ref;
  const viewport = useViewport();
  const buttonVariant = {
    viewport,
    ...variant
  };
  const getTokens = useThemeTokensCallback('Button', tokens, buttonVariant);
  return /*#__PURE__*/_jsx(ButtonBase, {
    ...props,
    tokens: getTokens,
    accessibilityRole: accessibilityRole,
    ref: ref
  });
});
Button.displayName = 'Button';
Button.propTypes = {
  ...a11yProps.types,
  ...buttonPropTypes,
  children: textAndA11yText
};
export default Button;